import { ISaveAsPatchState } from './saveAsPatchModalContext';
import { SaveAsPatchActionTypes, TSaveAsPatchAction } from './saveAsPatchModalActions';

export const saveAsPatchReducer = (state: ISaveAsPatchState, action: TSaveAsPatchAction): ISaveAsPatchState => {
	switch (action.type) {
		case SaveAsPatchActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case SaveAsPatchActionTypes.SET_TYPE_OF_CHANGES:
			return {
				...state,
				typeOfChanges: action.payload.typeOfChanges,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case SaveAsPatchActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case SaveAsPatchActionTypes.SET_PROPERTIES:
			return {
				...state,
				selectedProperties: action.payload.selectedProperties,
			};
		case SaveAsPatchActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case SaveAsPatchActionTypes.TOGGLE_HAS_OPEN_PRICE:
			return {
				...state,
				hasOpenPrice: !state.hasOpenPrice,
			};
		case SaveAsPatchActionTypes.CHANGE_OPEN_PRICE:
			return {
				...state,
				openPrice: action.payload.openPrice,
			};
		case SaveAsPatchActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD:
			return {
				...state,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
			};
		case SaveAsPatchActionTypes.CHANGE_TAX_PERCENT:
			return {
				...state,
				taxPercent: action.payload.taxPercent,
			};
		case SaveAsPatchActionTypes.TOGGLE_IN_STOP:
			return {
				...state,
				inStop: !state.inStop,
			};
		case SaveAsPatchActionTypes.TOGGLE_IS_COMMENT_VISIBLE:
			return {
				...state,
				isCommentVisible: !state.isCommentVisible,
			};
		case SaveAsPatchActionTypes.TOGGLE_IS_FISCALIZED:
			return {
				...state,
				isFiscalized: !state.isFiscalized,
			};
		case SaveAsPatchActionTypes.TOGGLE_IS_TAX_PERCENT_PROTECT_FROM_SYNC:
			return {
				...state,
				isTaxPercentProtectedFromSync: !state.isTaxPercentProtectedFromSync,
			};
		case SaveAsPatchActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case SaveAsPatchActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case SaveAsPatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SaveAsPatchActionTypes.RESET_FIELDS:
			return {
				...state,
				typeOfChanges: 'basedChanges',
				IDsSelectedRestaurant: [],
				selectedProperties: [],
				price: null,
				hasOpenPrice: false,
				openPrice: null,
				openPriceMaxThreshold: null,
				taxPercent: null,
				inStop: false,
				isCommentVisible: false,
				isFiscalized: false,
				isTaxPercentProtectedFromSync: false,
				activationSchedule: '',
				deactivationSchedule: '',
			};
		default:
			return state;
	}
};
